// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generic-dialog {
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  background-color: var(--dialog-background-color);
  border-radius: var(--dialog-border-radius);
  max-height: 90%;
  position: relative;

  > main {
    min-height: 0;
    flex-grow: 1;
  }
}

.generic-dialog-content-padding {
  padding: 0 var(--dialog-padding);
}

.generic-dialog-content-no-padding {
  display: contents;
}

.generic-dialog-width-narrow {
  width: var(--dialog-width-s);
}

.generic-dialog-width-medium {
  width: var(--dialog-width-m);
}

.generic-dialog-width-wide {
  width: var(--dialog-width-l);
}

.generic-dialog-height-small {
  height: var(--dialog-height-s);
}

.generic-dialog-height-tall {
  height: var(--dialog-height-l);
}

.generic-dialog-header {
  font-size: var(--font-size-xl);
  padding-top: var(--dialog-padding);
  padding-left: var(--dialog-padding);
  padding-right: var(--dialog-padding);
}

.generic-dialog-footer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-shrink: 0;
  gap: var(--dialog-element-gap);
  justify-content: flex-end;
  margin-top: var(--dialog-element-gap);
  padding-bottom: var(--dialog-padding);
  padding-left: var(--dialog-padding);
  padding-right: var(--dialog-padding);
}

.generic-dialog-footer > button {
  flex-shrink: 0;
  min-width: min(var(--text-button-min-width), 100%);
  max-width: 100%;
  min-height: var(--input-element-height);
  height: auto;
  padding-block: 0.5rem;
  overflow-wrap: anywhere;
}

.generic-dialog-loading-spinner-container {
  font-size: var(--font-size-l);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--dialog-element-gap);
  z-index: 1;

  > svg {
    font-size: var(--font-size-xl);
    color: var(--info-color);
  }
}

.generic-dialog-content-disabled-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background-color: var(--dialog-background-color);
}

.generic-dialog-footer > .generic-dialog-additional-button {
  min-width: unset;
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/generic-dialog/GenericDialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gDAAgD;EAChD,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;;EAElB;IACE,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,qCAAqC;EACrC,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,eAAe;EACf,uCAAuC;EACvC,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;;EAEV;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".generic-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  background-color: var(--dialog-background-color);\n  border-radius: var(--dialog-border-radius);\n  max-height: 90%;\n  position: relative;\n\n  > main {\n    min-height: 0;\n    flex-grow: 1;\n  }\n}\n\n.generic-dialog-content-padding {\n  padding: 0 var(--dialog-padding);\n}\n\n.generic-dialog-content-no-padding {\n  display: contents;\n}\n\n.generic-dialog-width-narrow {\n  width: var(--dialog-width-s);\n}\n\n.generic-dialog-width-medium {\n  width: var(--dialog-width-m);\n}\n\n.generic-dialog-width-wide {\n  width: var(--dialog-width-l);\n}\n\n.generic-dialog-height-small {\n  height: var(--dialog-height-s);\n}\n\n.generic-dialog-height-tall {\n  height: var(--dialog-height-l);\n}\n\n.generic-dialog-header {\n  font-size: var(--font-size-xl);\n  padding-top: var(--dialog-padding);\n  padding-left: var(--dialog-padding);\n  padding-right: var(--dialog-padding);\n}\n\n.generic-dialog-footer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  gap: var(--dialog-element-gap);\n  justify-content: flex-end;\n  margin-top: var(--dialog-element-gap);\n  padding-bottom: var(--dialog-padding);\n  padding-left: var(--dialog-padding);\n  padding-right: var(--dialog-padding);\n}\n\n.generic-dialog-footer > button {\n  flex-shrink: 0;\n  min-width: min(var(--text-button-min-width), 100%);\n  max-width: 100%;\n  min-height: var(--input-element-height);\n  height: auto;\n  padding-block: 0.5rem;\n  overflow-wrap: anywhere;\n}\n\n.generic-dialog-loading-spinner-container {\n  font-size: var(--font-size-l);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--dialog-element-gap);\n  z-index: 1;\n\n  > svg {\n    font-size: var(--font-size-xl);\n    color: var(--info-color);\n  }\n}\n\n.generic-dialog-content-disabled-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  background-color: var(--dialog-background-color);\n}\n\n.generic-dialog-footer > .generic-dialog-additional-button {\n  min-width: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
